var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsCircle = function SvgSmsCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3669,
    cy: 12.736,
    r: 10.6667,
    fill: "#FF6937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M8.73086 14.4029L6.25586 16.3473V7.73622C6.25586 7.58888 6.31439 7.44757 6.41858 7.34338C6.52276 7.2392 6.66407 7.18066 6.81142 7.18066H15.1447C15.2921 7.18066 15.4334 7.2392 15.5376 7.34338C15.6418 7.44757 15.7003 7.58888 15.7003 7.73622V14.4029H8.73086ZM8.34642 13.2918H14.5892V8.29177H7.36697V14.0612L8.34642 13.2918ZM10.1447 15.514H15.832L16.8114 16.2834V10.514H17.367C17.5143 10.514 17.6556 10.5725 17.7598 10.6767C17.864 10.7809 17.9225 10.9222 17.9225 11.0696V18.5696L15.4475 16.6251H10.7003C10.553 16.6251 10.4117 16.5666 10.3075 16.4624C10.2033 16.3582 10.1447 16.2169 10.1447 16.0696V15.514Z"
  })));
};
export default SvgSmsCircle;